
import React from 'react';
import { ShieldCheck, Award, Zap, Users } from 'lucide-react';

const TrustBadges: React.FC = () => {
  return (
    <div className="py-12 bg-white/5 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="flex flex-col items-center text-center group">
            <ShieldCheck className="w-10 h-10 text-[#1A4D2E] mb-3 group-hover:scale-110 transition-transform" />
            <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Ironclad Security</p>
            <p className="text-xs font-bold text-white">Bank-Level Encryption</p>
          </div>
          <div className="flex flex-col items-center text-center group">
            <Award className="w-10 h-10 text-[#FF6B35] mb-3 group-hover:scale-110 transition-transform" />
            <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Industry Standard</p>
            <p className="text-xs font-bold text-white">#1 Choice for Tree Pros</p>
          </div>
          <div className="flex flex-col items-center text-center group">
            <Zap className="w-10 h-10 text-yellow-500 mb-3 group-hover:scale-110 transition-transform" />
            <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Fast Implementation</p>
            <p className="text-xs font-bold text-white">14-Day Setup Promise</p>
          </div>
          <div className="flex flex-col items-center text-center group">
            <Users className="w-10 h-10 text-blue-400 mb-3 group-hover:scale-110 transition-transform" />
            <p className="text-[10px] font-black uppercase text-gray-400 tracking-widest">Social Proof</p>
            <p className="text-xs font-bold text-white">200+ Active Partners</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadges;
